// @flow
import * as React from 'react'
import SVGResponsive, { type PublicProps } from 'icon/SVGResponsive'

type Props = PublicProps & {
  strokeColor: string,
  strokeWidth: string,
}

export default class DismissIcon extends React.Component<Props> {
  static defaultProps = {
    title: 'Dismiss',
    strokeWidth: '2',
  }

  render = () => {
    const { strokeColor, strokeWidth, ...rest } = this.props

    return (
      <SVGResponsive {...rest} width={16} height={16}>
        <path
          stroke={strokeColor}
          strokeWidth={strokeWidth}
          d="M13.6 13.6L2.286 2.286M2.286 13.6L13.6 2.286"
          fill="none"
          strokeLinecap="square"
        />
      </SVGResponsive>
    )
  }
}
